import Nav from "./Nav";
import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchNames, addPurchase } from "./api";

const Addpurchase = () => {
  const queryClient = useQueryClient();

  const [value, setValue] = useState("");
  const [price, setPrice] = useState("");
  const [purchase, setPurchase] = useState("");

  // Fetch names for datalist
  const { data: names = [], isLoading } = useQuery({
    queryKey: ["names"],
    queryFn: fetchNames,
  });

  // Add purchase mutation
  const addMutation = useMutation({
    mutationFn: addPurchase,
    onSuccess: () => {
      alert("Purchase added successfully!");
      setValue("");
      setPrice("");
      setPurchase("");
      queryClient.invalidateQueries({ queryKey: ["names"] }); // optional: refetch names if needed
    },
  });

  const submitData = () => {
    if (!value || !price || !purchase) {
      alert("Please fill all fields");
      return;
    }
    addMutation.mutate({ value, price, purchase });
  };

  return (
    <>
      <Nav />
      <style>
        {`
          .addpurchase-container {
            margin: 5% auto;
            max-width: 500px;
            background: linear-gradient(135deg, #e0f7fa, #fff3e0);
            padding: 25px;
            border-radius: 15px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            animation: fadeIn 0.6s ease-in-out;
          }
          @keyframes fadeIn {
            from {opacity: 0; transform: translateY(15px);}
            to {opacity: 1; transform: translateY(0);}
          }
          h1 {
            text-align: center;
            color: #00796b;
            margin-bottom: 20px;
          }
          .form-control {
            border-radius: 8px;
          }
          .btn-primary {
            background: #00796b;
            border: none;
            border-radius: 8px;
            padding: 10px;
            font-size: 1.1em;
          }
          .btn-primary:hover {
            background: #004d40;
          }
        `}
      </style>

      <div className="addpurchase-container">
        <h1>Add Purchase</h1>

        <div className="form-floating mb-3 mt-3">
          <input
            list="browsers"
            id="browser"
            className="form-control"
            value={value}
            placeholder="Search"
            onChange={(e) => setValue(e.target.value)}
          />
          <datalist id="browsers">
            {!isLoading && names.map((s) => <option key={s}>{s}</option>)}
          </datalist>
          <label htmlFor="browser">Search by Name, Mobile, or Area</label>
        </div>

        <div className="form-floating mb-3 mt-3">
          <input
            type="number"
            className="form-control"
            onChange={(e) => setPrice(e.target.value)}
            value={price}
            placeholder="Enter Price"
          />
          <label htmlFor="price">Price</label>
        </div>

        <div className="form-floating mt-3 mb-3">
          <input
            type="date"
            className="form-control"
            onChange={(e) => setPurchase(e.target.value)}
            value={purchase}
          />
          <label htmlFor="purchase-date">Sales Date</label>
        </div>

        <button
          className="btn btn-primary w-100"
          onClick={submitData}
          disabled={addMutation.isLoading}
        >
          {addMutation.isLoading ? "Saving..." : "Save Purchase"}
        </button>
      </div>
    </>
  );
};

export default Addpurchase;
